module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier.f214f1fa.jpg";